import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

export const uber: GetCustomerCopyFunc = () => {
  return {
    displaySessionLimit: false,
  }
}
